import { render, staticRenderFns, recyclableRender, components } from "./qiun-error.vue?vue&type=template&id=0507f1f4&"
var renderjs
import script from "./qiun-error.vue?vue&type=script&lang=js&"
export * from "./qiun-error.vue?vue&type=script&lang=js&"
import style0 from "./qiun-error.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/qiun-data-charts/components/qiun-error/qiun-error.vue"
export default component.exports